import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const DescriptionTable = ({ details }) => (
  <div className="DescriptionTable">
    <table>
      <tbody>
        {details
          .filter((d) => d.label)
          .map((d, idx) => (
            <tr
              key={
                d.key ??
                `${typeof d.label === 'string' ? d.label : 'row'}-${idx}`
              }
            >
              <td>{d.label}</td>
              <td>{d.value}</td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);

DescriptionTable.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      value: PropTypes.node,
    })
  ).isRequired,
};

export default DescriptionTable;
